(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beastpan-sales"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('beastpan-sales')) {
  customElements.define('beastpan-sales', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.dialog = this.querySelector('dialog');
      this.querySelectorAll('[data-bp-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.querySelector('[data-bp-explore]').addEventListener('click', event => {
        event.preventDefault();
        this.dialog.close();
        const hero = document.getElementById('beastpan-product');
        hero?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        const title = hero?.querySelector('h1');
        title?.setAttribute('tabindex', '-1');
        title?.focus({ preventScroll: true });
      });
      if (this.dataset.popup !== 'true' || window.Shopify?.designMode || !this.dialog.showModal) return;
      let seen = false;
      try { seen = sessionStorage.getItem('beastpan-price-intro-v1') === 'seen'; } catch (_) {}
      if (seen || location.search.includes('customer_posted=true')) return;
      this.timer = setTimeout(() => {
        if (document.visibilityState !== 'visible' || document.querySelector('dialog[open]') || document.querySelector('#beastpan-notify input:focus')) return;
        this.dialog.showModal();
        try { sessionStorage.setItem('beastpan-price-intro-v1', 'seen'); } catch (_) {}
      }, 2400);
    }
    disconnectedCallback() { clearTimeout(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
